import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	RbidosAccessStatusEventModel,
	RbidosAccessExternalRequestModel,
} from 'Pages/registry_business_access_neo'
import { BgLogs } from 'Pages/ibro'
import { Callback } from 'Src/types/utilTypes'

export type ParamsConfirmEmail = {
	url: string
	code?: string
	callback?: (data) => void
	errorCallback?: Callback
	data?: any
}

export type InitLgos = {
	id: number
	name: string
	status: string
	infotecs_type: string
	is_deleted?: boolean
	consent?: boolean
	events?: RbidosAccessStatusEventModel[]
	external_requests: RbidosAccessExternalRequestModel[]
}

type emailCodeState = {
	codes: Record<string, string>
	logs: Record<string, InitLgos | BgLogs | null>
	successfulEmailConfirmation: boolean
}

export const emailCodeInitialState: emailCodeState = {
	codes: {},
	logs: {},
	successfulEmailConfirmation: false,
}

export namespace EmailNS {
	export type InitConfirmEmail = PayloadAction<{
		url: string
		callback?: (data) => void
		errorCallback?: Callback
		data?: any
	}>

	export type ConfirmEmail = PayloadAction<ParamsConfirmEmail>
	export type SendConfirmEmail = PayloadAction<ParamsConfirmEmail>
	export type SetCodeEmail = PayloadAction<ParamsConfirmEmail>
	export type SetLogs = PayloadAction<{ url: string; data: InitLgos | BgLogs }>
	export type SetSuccessfulEmailConfirmation = PayloadAction<boolean>
}

export const emailSlice = createSlice({
	name: 'email_neo_ibro',
	initialState: emailCodeInitialState,
	reducers: {
		initConfirmEmail: (state, action: EmailNS.InitConfirmEmail) => {},
		confirmEmail: (state, action: EmailNS.ConfirmEmail) => {},
		sendConfirmEmail: (state, action: EmailNS.SendConfirmEmail) => {},
		setCodeEmail: (state, action: EmailNS.SetCodeEmail) => {
			state.codes[action.payload.url] = action.payload.code
		},
		setLogs: (state, action: EmailNS.SetLogs) => {
			state.logs[action.payload.url] = action.payload.data
		},
		setSuccessfulEmailConfirmation: (state, action: EmailNS.SetSuccessfulEmailConfirmation) => {
			state.successfulEmailConfirmation = action.payload
		},
	},
})
